/* ⚛ REACT */
import { useEffect, useRef, useState } from "react";

/* 📦 LIBS */
import { toast } from 'react-toastify';
import { useNavigate, useParams, useLocation } from "react-router";
import { useTranslation } from "react-i18next";
import { useTour } from "@reactour/tour";

/* 🧩 COMPONENTS */
import { Button, Input, Label, SelectEquipment, CustomLoading, Pagination, Breadcrumb, Modal, Calendar, InputCheckbox, InputRadio } from "../../../Components/index.js";
import { Graph } from "../Components/index.js";

/* 🔗 SERVICE */
import { HistoricServices } from "../../../Services/historicosServices/index.js";

/* 🧠 REDUX */
import { store } from "../../../Redux/Store/index.js";
import { useSelector } from "react-redux/es/hooks/useSelector";
import { changeHistoricGraphData, changeHistoricListData, changeHistoricLoading, changeHistoricLoadingList, ChangeEquipament, changeModal } from "../../../Redux/Actions/index.js";

/* 📁 ASSETS*/
import { Download, Ajuda } from "../../../Assets/icons";

/* 🎨 STYLES */
import {Container, HeaderContainer, BodyContainer, ContainerTable, Table, TableHeader, TableRow, 
    TableCell, ContainerSpinner, NoData, TableCellItem, GraphContainer, GraphTitle,
    DownloadiconContainer, ButtonDownload } from "./styles";
import { CalendarContainer, OptionsContainer, ButtonsContainer, WarningText, ImageIcon, Subtitle } from "../../Dashboards/Equipamento/styles.js";
import { HelpIcon } from "../../styles.js";

/* 🔧 UTILS */
import { isValidStartData, isValidEndData } from "../../../util/validate.js";
import { historySteps } from "../../../util/tour/history.js";

const HistoricGeneral = () => {
    const { t } = useTranslation();

    document.title = t("reports.sub-items.history.general.document-title");
    const { id } = useParams();

    const navigationFlow =  [
        { text: 'reports', page: null },
        { text: 'history', page: null },
    ];

    const downloadMethods = [
        {id: 'legacy', label: t("input-radio.legacy")},
        {id: 'newStandard', label: t("input-radio.new-standard")}
    ];

    const downloadExtensions = [
        {id: 'xlsx', label: '.xlsx'},
        {id: 'ods', label: '.ods'},
        {id: 'csv', label: '.csv'},
        {id: 'xls', label: '.xls'},
        {id: 'tsv', label: '.tsv'},
        {id: 'pdf', label: '.pdf'},
        {id: 'html', label: '.html'}
    ];

    const navigate = useNavigate();
    const location = useLocation();

    const { isOpen, setIsOpen, currentStep, setSteps } = useTour();
    
    let data1 = location.state?.data1;
    let data2 = location.state?.data2;
    
    const services = useRef(new HistoricServices());
    const analysisMode = useRef(false);
    const readingMode = useRef(false);
    const method = useRef(downloadMethods[1].id);
    const extension = useRef(downloadExtensions[0].id);

    const isLoading = useSelector(state => state.HistoricReducer.isLoading);
    const isLoadingList = useSelector(state => state.HistoricReducer.isLoadingList);
    const listData = useSelector(state => state.HistoricReducer.listData);
    const graphData = useSelector(state => state.HistoricReducer.graphData);
    const listPagination = useSelector(state => state.HistoricReducer.pagination);
    const Cities = useSelector(state => state.HistoricReducer.cities);
    const city = useSelector(state => state.HistoricReducer.city);
    const equipaments = useSelector(state => state.HistoricReducer.equipamentList);
    
    const [datainicio, setDatainicio] = useState(data1 ? data1 : new Date().toISOString(Date.now() - 3 * 60 * 60 * 1000).slice(0, 10)+'T00:00');
    const [datafim, setDatafim] = useState(data2 ? data2 : new Date(Date.now() - 3 * 60 * 60 * 1000).toISOString().slice(0, 10)+'T23:59:59');
    const [selectedMethod, setSelectedMethod] = useState(method.current);
    const [selectedMode, setSelectedMode] = useState(null);
    
    const formatarDataParaYMDHMS = (data) => {
        const year = data.getFullYear();
        const month = String(data.getMonth() + 1).padStart(2, '0');
        const day = String(data.getDate()).padStart(2, '0');
        const hours = String(data.getHours()).padStart(2, '0');
        const minutes = String(data.getMinutes()).padStart(2, '0');
        const seconds = String(data.getSeconds()).padStart(2, '0');
        
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }

    const formatarDataParaMDHMS = (data) => {
        let newdata = new Date(data);        
        return t("date.day-month-hour", {date: newdata, format: "dayMonthAndHour"});
    }
    
    const getData = async() => {
        store.dispatch(changeHistoricLoading(true));
        let startData = formatarDataParaYMDHMS(new Date(datainicio));
        let endData = formatarDataParaYMDHMS(new Date(datafim));
        await Promise.all([
            services.current.getGeneralData(id, startData, endData),
            services.current.getGraphData(id, startData, endData)
        ]);
        store.dispatch(changeHistoricLoading(false));
        store.dispatch(changeHistoricLoadingList(false));
    }

    useEffect(() => {
        services.current.getEquipamentos();
        services.current.getCities();
        setSteps(historySteps(t));

        return () => {
            setSteps([]);       
        };
    }, []);

    useEffect(() => {
        const getData = async() => {
            store.dispatch(changeHistoricLoading(true));
            let startData = formatarDataParaYMDHMS(new Date(data1 ? data1 : new Date().toISOString(Date.now() - 3 * 60 * 60 * 1000).slice(0, 10) + 'T00:00'));
            let endData = formatarDataParaYMDHMS(new Date(data2 ? data2 : new Date(Date.now() - 3 * 60 * 60 * 1000).toISOString().slice(0, 16)));
            await Promise.all([
                services.current.getGeneralData(id, startData, endData),
                services.current.getGraphData(id, startData, endData)
            ]);
            store.dispatch(changeHistoricLoading(false));
            store.dispatch(changeHistoricLoadingList(false));
        }
        if(id !== null && id !== undefined && id !== '' && id !== 'null' && id !== 'undefined'){
            store.dispatch(ChangeEquipament(id));
            getData();
        }else{
            store.dispatch(changeHistoricListData({
                data: [],
                titles: [],
            }))
            store.dispatch(changeHistoricGraphData([]));
            store.dispatch(changeHistoricLoading(false));
            store.dispatch(changeHistoricLoadingList(false));
        }
    }, [id, data1, data2]);

    useEffect(() => {
        if(id !== null && id !== undefined && id !== '' && id !== 'null' && id !== 'undefined'){
            setTimeout(() => {
                services.current.changeCity(id);
            }, 6000);
        }
    }, [id]);

    const changepage = async(page) => {
        store.dispatch(changeHistoricLoadingList(true));
        let startData = formatarDataParaYMDHMS(new Date(datainicio));
        let endData = formatarDataParaYMDHMS(new Date(datafim));
        await services.current.getGeneralData(id, startData, endData, page);
        store.dispatch(changeHistoricLoadingList(false));
    }

    const handleTour = async() => {
        if (id === null || id === undefined || id === '' || id === 'null' || id === 'undefined') {
            toast(t("message.history.handle-tour"), {
                position: "top-center",
                type: 'info',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        } else {
            setIsOpen(true);
        }
    }

    return (
        <>
            <Container>
                <div className="header">
                    <Breadcrumb flow={navigationFlow}/>
                    <Button color={"green"} onClick={() => handleTour()} icon={<HelpIcon className={"icon"} src={Ajuda} />}  disabled={isLoading} padding={"8px 10px"} radius={"3px"} width={"44px"} />
                </div>
                <HeaderContainer $top>
                    <div id="selects" className="selects">
                        <SelectEquipment Color={'white'} options={Cities} value={city} onChange={(e) => services.current.filterEquipaments(e.target.value)} />
                        <SelectEquipment Color={'white'} options={equipaments} value={id} onChange={(e) => {
                            if(e.target.value === '' || e.target.value === null || e.target.value === undefined){
                                toast(t("message.select-equipment"), {
                                    position: "top-center",
                                    type: 'info',
                                    autoClose: 3000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: false,
                                    draggable: false,
                                    progress: undefined,
                                });
                                return
                            }else{
                                services.current.changeCity(e.target.value);
                                navigate(`/historico/${e.target.value}`,{state: {data1: datainicio, data2: datafim}});
                            }
                        }} />
                    </div>
                    <div className="buttons-container">
                        {id !== null && id !== undefined && id !== '' && id !== 'null' && id !== 'undefined' && <>
                            <Button width={'fit-content'} text={t("buttons.detail")} onClick={() => {
                                navigate(`/historico/detalhes/${id}`, {state: {data1: datainicio, data2: datafim}})}}></Button>
                            {equipaments.find(equip => equip.id === id)?.type?.id === '1f4d0674-1e7a-48c5-925f-87e2d99bcda5' &&
                                <>
                                    <Button width={'fit-content'} text={t("buttons.analyses")} onClick={() => {
                                        navigate(`/historico/analises/${id}`, {state: {data1: datainicio, data2: datafim}})}}></Button>
                                    <Button width={'fit-content'} text={t("buttons.operation-mode")} onClick={() => {
                                        navigate(`/historico/operacao/${id}`, {state: {data1: datainicio, data2: datafim}})}}></Button>
                                </>
                            }
                        </>}
                    </div>
                </HeaderContainer>

                {id !== null && id !== undefined && id !== '' && id !== 'null' && id !== 'undefined' && 
                    <HeaderContainer id="date-inputs">
                        <div>
                            <Label text={t("inputs.initial-date.label")} aling="flex-start"/>
                            <Input 
                                aling="flex-start"
                                id='datainicio' 
                                name='datainicio' 
                                type="datetime-local" 
                                placeholder={t("inputs.initial-date.placeholder")}
                                value={datainicio}
                                max={datafim}
                                // innerRef={UserField}
                                invalidMessage={t("inputs.initial-date.invalid-message")}
                                validationFunction={(text) => isValidStartData(text, datafim)}
                                onchange={(text) => text && setDatainicio(text)}> 
                            </Input>
                        </div>
                        <div>
                            <Label text={t("inputs.final-date.label")} aling="flex-start"/>
                            <Input 
                                aling="flex-start"
                                id='datafim' 
                                name='datafim' 
                                type="datetime-local" 
                                placeholder={t("inputs.final-date.placeholder")}
                                value={datafim}
                                min={datainicio}
                                invalidMessage={t("inputs.final-date.invalid-message")}
                                validationFunction={(text) => isValidEndData(datainicio, text)}
                                onchange={(text) => (text && !isNaN(new Date(text).getTime())) && setDatafim(text)}> 
                            </Input>
                        </div>
                        <div className="buttons-container">
                            <Button text={t("buttons.apply")} width={'fit-content'} id={"apply-button"}  onClick={() => getData()} disabled={isOpen && (currentStep === 1  || currentStep === 2)}/>
                            <ButtonDownload $width={'fit-content'} $color={'green'} id={"download-excel"}
                                onClick={() => store.dispatch(changeModal('reports'))}
                                disabled={isOpen && (currentStep === 1  || currentStep === 2)}
                            >
                                <DownloadiconContainer src={Download} className="icon" />
                            </ButtonDownload>
                        </div>
                    </HeaderContainer>
                }

                <BodyContainer>
                    {isLoading?
                        <CustomLoading width={'150px'} height={'150px'}/>
                    :
                    id !== null && id !== undefined && id !== '' && id !== 'null' && id !== 'undefined' &&
                        <>
                            {
                                graphData?.map((graph, index) => (
                                    <GraphContainer key={index}>
                                        {Object.values(graph)[0][0].data.length > 0 ?
                                            <>
                                                <GraphTitle>
                                                    {Object.keys(graph)[0]}
                                                </GraphTitle>
                                                <Graph data={JSON.parse(JSON.stringify(Object.values(graph)[0]))}/>
                                            </>
                                        :<></>}
                                    </GraphContainer>
                                ))        
                            }

                            {isLoadingList?
                                <CustomLoading width={'150px'} height={'150px'}/>
                            :
                                listData?.data.length > 0 ?
                                    <ContainerTable>
                                        <Table>
                                            <thead>
                                                <TableRow>
                                                    {listData.titles.map((item, index) => (
                                                        <TableHeader key={index}>{item}</TableHeader>
                                                    ))}
                                                </TableRow>
                                            </thead>
                                            <tbody>
                                                    {listData?.data.map((item, index) => (
                                                        <TableRow key={index}>
                                                            {listData.titles.map((title, index) => (
                                                                <TableCell key={index}>
                                                                    <TableCellItem $alarm={item.Alarms[title]}>
                                                                        {title === 'Horário' || title === 'horario' || title === 'Time' ? formatarDataParaMDHMS(item.Values[title]) : 
                                                                        title === 'Auto ajuste' ? parseFloat(item.Values[title]) ? parseFloat(item.Values[title]).toFixed(5) : item.Values[title] :
                                                                        parseFloat(item.Values[title]) ? parseFloat(item.Values[title]).toFixed(2) : item.Values[title]}
                                                                    </TableCellItem>
                                                                </TableCell>
                                                            ))}
                                                        </TableRow>
                                                    ))}
                                            </tbody>
                                        </Table>
                                        <Pagination last_page={listPagination?.last_page} currentpage={listPagination?.current_page} changepage={changepage}/>
                                    </ContainerTable>
                                :
                                    <ContainerSpinner>
                                        <NoData>{t("reports.sub-items.history.general.no-data")}</NoData>
                                    </ContainerSpinner>
                            }
                        </>}
                </BodyContainer>
            </Container>

            <Modal title={t("modal.download.title")} id={"download-modal"} name={'reports'} width={'780px'} height={'90%'}>                
                <CalendarContainer>
                    <Calendar title={t("calendar.title.initial-date")}  selectedDate={datainicio} onDateChange={(date) => setDatainicio(date.toISOString().slice(0, 10) + "T00:00")} />
                    <Calendar title={t("calendar.title.final-date")} selectedDate={datafim} onDateChange={(date) => setDatafim(date.toISOString().slice(0, 10) + "T23:59:59")}/>
                </CalendarContainer>
                <OptionsContainer>
                    <div className="container">
                        <Subtitle>{t("modal.report.subsections-title.setup-file")}:</Subtitle>
                        <div className="file-setup">
                            <InputCheckbox text={t("checkbox.analysis-mode")} checked={analysisMode.current} onChange={(value) => {analysisMode.current = value; return true}}/>
                            <InputCheckbox text={t("checkbox.reading-mode")} checked={readingMode.current} disabled={selectedMethod === downloadMethods[0].id} onChange ={(value) => {readingMode.current = value; setSelectedMode(value); return true}}/>
                        </div>
                        {selectedMode &&
                            <WarningText $float={'right'}>
                                *{t("modal.report.warnings.option-not-available")}
                            </WarningText>
                        }
                    </div>
                    <div className="container">
                        <Subtitle>{t("modal.report.subsections-title.spreadsheet-type")}:</Subtitle>
                        <div className="spreadsheet-setup">
                            <InputRadio name={'method'} options={downloadMethods} value={downloadMethods[1].id} 
                            onChange ={(value) => {method.current = value; setSelectedMethod(value); return true}}/>
                        </div>
                    </div>
                    <div className="container">
                        <Subtitle>{t("modal.report.subsections-title.format")}:</Subtitle>
                        <div className="file-format">
                            <InputRadio name={'format'} options={downloadExtensions} value={downloadExtensions[0].id} disabled={selectedMethod === downloadMethods[0].id ? [1, 2, 3, 4, 5, 6] : (selectedMode ? [5, 6] : [])} onChange={(value) => {extension.current = value; return true}}/>
                        </div>
                        {selectedMethod === downloadMethods[0].id &&
                            <WarningText $float={'right'}>
                                *{t("modal.report.warnings.compatible-format")}
                            </WarningText>
                        }
                        
                    </div>
                </OptionsContainer>

                <ButtonsContainer $justify={'space-between'} $sendToEmail={(((new Date(datafim) - new Date(datainicio)) / (1000 * 60 * 60 * 24)) > 45 && (selectedMethod !== downloadMethods[0].id))}>
                    <Button 
                        text={t("buttons.send-by-email")} 
                        color={"green"} 
                        // icon={<ImageIcon className={"icon"} src={Download} $disabled={isOpen && currentStep === 3}/>} 
                        width={'220px'} 
                        disabled={isOpen && currentStep === 3}
                        onClick={() => {
                            const startDate = `${new Date(datainicio).toISOString().slice(0, 10)}T00:00`;
                            const endDate = `${new Date(datafim).toISOString().slice(0, 10)}T23:59:59`;
                            const methodOld = method.current === 'legacy';
                            
                            services.current.getExcel(
                                id,
                                startDate,
                                endDate,
                                analysisMode.current,
                                readingMode.current,
                                methodOld,
                                extension.current
                            );
                        }}
                    />
                    <Button 
                        id={"download"}
                        text={t("buttons.download")} 
                        color={"green"} 
                        icon={<ImageIcon className={"icon"} src={Download} />} 
                        width={'220px'} 
                        disabled={(((new Date(datafim) - new Date(datainicio)) / (1000 * 60 * 60 * 24)) > 45) || (isOpen && currentStep === 3)}
                        onClick={() => {
                            const startDate = `${new Date(datainicio).toISOString().slice(0, 10)}T00:00`;
                            const endDate = `${new Date(datafim).toISOString().slice(0, 10)}T23:59:59`;
                            const methodOld = method.current === 'legacy';
                            
                            services.current.getExcel(
                                id,
                                startDate,
                                endDate,
                                analysisMode.current,
                                readingMode.current,
                                methodOld,
                                extension.current
                            );
                        }}
                    />
                </ButtonsContainer>
                {((new Date(datafim) - new Date(datainicio)) / (1000 * 60 * 60 * 24)) > 45 && (selectedMethod !== downloadMethods[0].id) &&
                    <WarningText>
                        *{t("modal.report.warnings.long-period")}
                    </WarningText>
                }
            </Modal>
        </>
    );
}

export default HistoricGeneral;
